import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import JobList from '../Jobs/JobList';

class MissingPOJobs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            offset: 0,
            status: 'completed',
            waste_journey: 0,
            searchTerm: '',
            po_number: '',
            selected_job_id: '',
        };
    }

    loadJobsFromServer = () => {
        axios
            .get(this.props.url, {
                params: {
                    limit: this.props.perPage,
                    offset: this.state.offset,
                    status: this.state.status,
                    waste_journey: this.state.waste_journey,
                    missingPoJobs: true,
                },
                responseType: 'json',
            })
            .then((response) => {
                this.setState({
                    data: response.data.jobs,
                    pageCount: Math.ceil(response.data.total / this.props.perPage),
                });
            })
            .catch(() => {});
    };

    componentDidMount() {
        this.loadJobsFromServer();
    }

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    };

    handlePOChange = (e) => {
        this.setState({ po_number: e.target.value });
    };

    handleJobIDChange = (id) => {
        this.setState({ selected_job_id: id });
    };

    handleClick = (url) => {
        window.location.href = url;
    };

    handleSearchClick = () => {
        if (this.state.searchTerm !== '') {
            axios
                .post(this.props.searchUrl, {
                    method: 'POST',
                    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                    data: {
                        search_term: this.state.searchTerm,
                    },
                    responseType: 'json',
                })
                .then((response) => {
                    this.setState({
                        data: response.data.jobs,
                        pageCount: Math.ceil(response.data.total / this.props.perPage),
                        searchTerm: '',
                    });
                })
                .catch((error) => {
                    toastr.error('There was a problem with submitting the form. Please try again.');
                });
        }
    };

    handleModalClick = () => {
        axios
            .post(this.props.updatePOUrl, {
                method: 'POST',
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                data: {
                    id: this.state.selected_job_id,
                    po_number: this.state.po_number,
                },
                responseType: 'json',
            })
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                if (error.response.status === 422) {
                    toastr.error('The input field cannot be empty!');
                } else {
                    toastr.error('There was a problem with submitting the form. Please try again.');
                }
            });
    };

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.loadJobsFromServer();
        });
    };

    render() {
        return (
            <Fragment>
                {/*<div className="row mt-4">*/}
                {/*    <div className="col-12">*/}
                {/*        <div className="form-inline">*/}
                {/*            <div className="col-10 pl-0">*/}
                {/*                <input type="text" className="form-control w-100" placeholder="Search job..." value={this.state.searchTerm} onChange={(e) => this.handleSearchChange(e)} />*/}
                {/*            </div>*/}
                {/*            <div className="col-2 pr-0">*/}
                {/*                <button className="btn btn-success w-100" onClick={() => this.handleSearchClick()}>Search</button>*/}
                {/*            </div>  */}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="row pt-4">
                    <div className="col-12">
                        <div className="cw-bg-grey py-1 d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="py-2 pl-2 text-white">Jobs</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <JobList
                    data={this.state.data}
                    loadJobsMissingPO={true}
                    handleJobIDChange={this.handleJobIDChange}
                    onClick={this.handleClick}
                    baseUrl={this.props.baseUrl}
                    isAdmin={this.props.isAdmin}
                />
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />

                <div
                    className="modal fade"
                    id="exampleModal"
                    tabIndex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header bg-cw-primary">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Modal title
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    onClick={() => this.setState({ po_number: '', selected_job_id: '' })}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Purchase Order Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.po_number}
                                        onChange={(e) => this.handlePOChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => this.setState({ po_number: '', selected_job_id: '' })}
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-cw-primary"
                                    onClick={() => this.handleModalClick()}
                                >
                                    Save changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

if (document.getElementById('missing-po-jobs')) {
    let element = document.getElementById('missing-po-jobs');

    ReactDOM.render(
        <MissingPOJobs
            url={element.dataset.url}
            searchUrl={element.dataset.searchurl}
            updatePOUrl={element.dataset.update_po_url}
            perPage={10}
            baseUrl={element.dataset.base_url}
            domain={element.dataset.domain}
            isAdmin={element.dataset.is_admin}
        />,
        element
    );
}

export default MissingPOJobs;
